import angular from 'angular'

import { wrap, isFinite } from 'lodash-es'

import extractRawElm from '../utils/extract-raw-elm'

angular
  .module('ggs.timeago')
  .factory('timeago', TimeagoProvider)
  .directive('ggsTimeago', TimeagoDirective)

const INTERVAL_DELAY = 60e3
const INTERVAL_INF_LOOP = 0
const INTERVAL_SKIP_APPLY = false

function TimeagoProvider(
  $interval,
  $rootScope,
  qh,
  debugObj,
  LazyResource) {

  let formatFunc = null
  let recalcEmitter = null
  let intervalId = null

  const elmList = []
  const timeList = []
  const lastList = []

  const proxy = LazyResource(
    'setup',
    'destroy',
    'release',
    'register',
    'recalcAll')

  proxy
    .setup.allow(setup)
    .const({
      _elmList: elmList,
      _timeList: timeList,
      _lastList: lastList
    })

  $rootScope.$on(
    '$destroy',
    proxy.destroy)

  return debugObj('timeago', proxy)

  function setup(realFormatFunc, realRecalcEmitter) {
    formatFunc = realFormatFunc
    recalcEmitter = realRecalcEmitter
    recalcEmitter.on(proxy.recalcAll)
    intervalId = $interval(proxy.recalcAll, INTERVAL_DELAY, INTERVAL_INF_LOOP, INTERVAL_SKIP_APPLY)

    proxy
      .destroy.allow(destroy)
      .release.allow(release)
      .register.allow(register)
      .recalcAll.allow(recalcAll)
  }

  function destroy() {
    return qh.join(
      $interval.cancel(intervalId),
      recalcEmitter.off(proxy.recalcAll))
  }

  function recalcAll() {
    const now = Date.now()
    for (let index = 0, length = elmList.length; index !== length; index++) {
      const elm = elmList[index]
      const time = timeList[index]
      const word = formatFunc(now, time)
      if (lastList[index] === word) {
        continue
      }

      lastList[index] = word
      elm.textContent = word
    }
  }

  function register($elm, time) {
    const elm = extractRawElm($elm)
    elmList.push(elm)
    timeList.push(time)

    const now = Date.now()
    const word = formatFunc(now, time)
    lastList.push(word)
    elm.textContent = word
  }

  function release($elm) {
    const elm = extractRawElm($elm)
    const index = elmList.indexOf(elm)
    if (index === -1) {
      return
    }

    elmList.splice(index, 1)
    timeList.splice(index, 1)
    lastList.splice(index, 1)
  }
}

function TimeagoDirective($parse, timeago) {
  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      const ngExp = $parse($attr.ggsTimeago)
      const time = ngExp($scope)
      if (isFinite(time)) {
        timeago.register($elm, time)
      } else {
        $scope.$watch(ngExp, (time) => {
          if (isFinite(time)) {
            timeago.register($elm, time)
          }
        })
      }

      $scope.$on('$destroy', wrap($elm, timeago.release))
    }
  }
}
